import "./ourClub.css"
import OurClubData from "./ourClubData"

const ourClub = () => {
    return(
        <div className="ourclub">
            <h1>Our ITO </h1>
            <p>Iyarkai Tamizhan Organisation.</p>

            <OurClubData
            className="first-des"
            heading="About ITO"
            text="Iyarkai Tamizhan Organization is a grassroots initiative founded in 2023, devoted to cultivating environmental awareness and sustainability in Tamil Nadu, India. Grounded in the conviction that nurturing our natural surroundings is essential for a flourishing community and a sustainable future, we actively combat climate change and ecological decline by planting trees. Our diverse volunteers, driven by passion, collaborate to plant and nurture trees in both urban and rural settings. Going beyond tree planting, we organize educational workshops, awareness campaigns, and community outreach programs, equipping individuals with the knowledge and resources to become environmental stewards. Through partnerships with local communities, governmental bodies, and allied organizations, we aim to foster a greener, healthier, and more resilient Tamil Nadu. We invite you to join us in safeguarding our precious natural heritage for future generations, as together, we can create a significant impact, one tree at a time."
            img1="/assert/1.JPG"
            img2="/assert/2.JPG"
            />

        </div>
    );
};

export default ourClub;